import { MoreHorizontal, ChevronRight } from "lucide-react";
import { msg } from "@lingui/core/macro";
import { Button } from "@/components/ui/button";
import { i18n } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface ActionSubItem {
  label: string;
  onClick: () => void;
}

export interface ActionItem {
  label: string;
  onClick?: () => void;
  destructive?: boolean;
  subItems?: ActionSubItem[];
}

interface ActionsCellProps {
  items: ActionItem[];
  triggerClassName?: string;
}

export function ActionsCell({ items, triggerClassName }: ActionsCellProps) {
  if (items.length === 0) {
    return (
      <Button variant="ghost" size="icon" className={cn("h-8 w-8", triggerClassName)}>
        <MoreHorizontal className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className={cn("h-8 w-8", triggerClassName)}>
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">{i18n._(msg`Actions`)}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {items.map((item) =>
          item.subItems ? (
            <DropdownMenuSub key={item.label}>
              <DropdownMenuSubTrigger className={item.destructive ? "text-(--color-danger-text)" : undefined}>
                <span className="flex-1">{item.label}</span>
                <ChevronRight className="ml-auto h-4 w-4 opacity-50" />
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent>
                {item.subItems.map((sub) => (
                  <DropdownMenuItem key={sub.label} onClick={sub.onClick}>
                    {sub.label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          ) : (
            <DropdownMenuItem
              key={item.label}
              onClick={item.onClick}
              className={item.destructive ? "text-(--color-danger-text) focus:text-(--color-danger-text)" : undefined}
            >
              {item.label}
            </DropdownMenuItem>
          ),
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
